<!-- Template -->
<div class="node-details-container  text-grey">
  <mat-card class="mat-elevation-z2 main-card shadow-none">
    <!-- Action Bar -->
    <div class="action-bar">
      <button *ngIf="showEdit" class="default-btn" (click)="editNode()" triggers="hover" ngbTooltip="Edit Node Commands">
        <span class="bi bi-pencil-square"></span> Edit
      </button>
    </div>

    <mat-card-content class="pt-1 px-2">
      <section class="node-overview">
        <h2>Overview</h2>
        <div class="info-grid-overview">
          <div class="info-item">
            <mat-icon>cloud</mat-icon>
            <div class="info-content">
              <span class="label">Deployment Name</span>
              <span class="value">{{ nodeDepName || "NA" }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon>flag</mat-icon>
            <div class="info-content">
              <span class="label">State</span>
              <span class="value">{{ node.state }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon>schedule</mat-icon>
            <div class="info-content">
              <span class="label">Scheduler State</span>
              <span class="value">{{ node.schedulerState || "NA" }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon>receipt_long</mat-icon>
            <div class="info-content">
              <span class="label">Billed Hours</span>
              <span class="value">{{ node.billedHours || "NA" }}</span>
            </div>
          </div>
        </div>
      </section>

      <mat-divider></mat-divider>

      <section class="additional-information">
        <h2>Additional Information</h2>
        <div class="info-grid-compact">
          <div class="info-item-compact">
            <span class="label">Node Type</span>
            <span class="value">{{ node.nodeType }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Instance Type</span>
            <span class="value">{{ node.instanceType || "NA" }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">CPU Usage</span>
            <span class="value">{{ node.cpuUsage ? node.cpuUsage + '%' : '-' }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">RAM Usage</span>
            <span class="value">{{ node.ramUsage ? node.ramUsage + '%' : 'NA' }}</span>
          </div>
          @if (node.gpuName) {
          <div class="info-item-compact">
            <span class="label">GPU Name</span>
            <span class="value">{{ node.gpuName || "NA" }}</span>
          </div>
          }
          @if (node.gpuUsage > 0){
            <div class="info-item-compact">
              <span class="label">GPU Usage</span>
              <span class="value">{{ node.gpuUsage ? node.gpuUsage + '%' : 'NA' }}</span>
            </div>
          }
          @if (node.gpuMemoryUsage > 0){
            <div class="info-item-compact">
              <span class="label">GPU Memory Usage</span>
              <span class="value">{{ node.gpuMemoryUsage ? node.gpuMemoryUsage + '%' : 'NA' }}</span>
            </div>
          }
          @if(node.gpuRamSize > 0){
          <div class="info-item-compact">
            <span class="label">GPU Ram Size</span>
            <span class="value">{{ node.gpuRamSize || "NA" }}</span>
          </div>
          }
          <div class="info-item-compact">
            <span class="label">Slurm Name</span>
            <span class="value">{{ node.slurmVmName || "NA" }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">
              Node Group
              <i class="bi bi-info-circle-fill synchpc-primary" placement="left" container="body" [autoClose]="true"
                 (mouseover)="getTooltip('nodeGroup')" triggers="hover" [ngbTooltip]="htmlContentTooltip">
              </i>
            </span>
            <span class="value">
              {{ node.azureServiceName || "NA" }}
              <button type="button"
                      class="edit-btn ms-3"
                      *ngIf="nodeGroupChangeAccess && !isMonitor"
                      (click)="setNodeGroup()"
                      triggers="hover" ngbTooltip="Edit Node Group">
                <span class="bi bi-pencil"></span>
              </button>
            </span>
          </div>
          <div class="info-item-compact">
            <span class="label">HPC Units Used</span>
            <span class="value">{{ node.hpcUnitsUsed }} Units</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Platform</span>
            <span class="value">{{ node.vmPlatform }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Image Name</span>
            <span class="value">{{ node.imageName || "NA" }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Operating System</span>
            <span class="value">{{ node.vmOs || "NA" }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Processor</span>
            <span class="value">{{ node.processor || "NA" }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Alloc/Total</span>
            <span class="value">{{ node.allocTotal }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Connector Type</span>
            <span class="value">{{ node.connectorType || "NA" }}</span>
          </div>
          <div class="info-item-compact" *ngIf="rdProtocolChangeAccess">
            <span class="label">RD Protocol</span>
            <select class="form-select" [ngModel]="rdProtocol" (change)="updateRdProtocol($event)">
              <option value="-1">Deployment Default</option>
              <option value="0">RDP or VNC</option>
              <option value="1">PCoIP</option>
              <option value="2">Dcv</option>
            </select>
          </div>
          <div class="info-item-compact">
            <span class="label">Mapped Users</span>
            <select *ngIf="node?.mappedUsers?.length" class="form-select">
              <option *ngFor="let user of node?.mappedUsers" [value]="user">
                {{ user }}
              </option>
            </select>
            <span class="value" *ngIf="!node?.mappedUsers?.length">NA</span>
          </div>
          <div class="info-item-compact">
            <span class="label">
              Action Time
              <i class="bi bi-info-circle-fill synchpc-primary" placement="right" container="body" [autoClose]="true"
                 (mouseover)="getTooltip('actionTime')" triggers="hover" [ngbTooltip]="htmlContentTooltip">
              </i>
            </span>
            <span class="value">{{ node.actionTime }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Identifier Tag</span>
            <span class="value">{{ node.identifierTag || "NA" }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Node Description</span>
            <span class="value">{{ node.description || "NA" }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Reserved</span>
            <span class="value">{{ node.reserved || "NA" }}</span>
          </div>
          @if (node.hostNodeId) {
          <div class="info-item-compact">
            <span class="label">Host Node ID</span>
            <span class="value">{{ node.hostNodeId || "NA" }}</span>
          </div>
          }
          @if (node.hostNodeVmId) {
          <div class="info-item-compact">
            <span class="label">Host Node VM ID</span>
            <span class="value">{{ node.hostNodeVmId || "NA" }}</span>
          </div>
          }
          <div class="info-item-compact">
            <span class="label">Vm Shutdown Time</span>
            <span class="value">{{ (node.vmShutDownTime | date:'medium') || "NA" }}</span>
          </div>
        </div>
      </section>
      @if (nodeNetwork) {
        <mat-divider></mat-divider>
        <section class="additional-information">
          <h2>Network Details</h2>
          <div class="info-grid-compact">
            <div class="info-item-compact" *ngIf="nodeNetwork.privateIp && nodeNetwork.privateIp !== 'NA' && nodeNetwork.privateIp.trim() !== ''">
              <span class="label">IP Address</span>
              <span class="value">{{ nodeNetwork.privateIp || "NA" }}</span>
            </div>
            <div class="info-item-compact" *ngIf="nodeNetwork.publicIp && nodeNetwork.publicIp !== 'NA' && nodeNetwork.publicIp.trim() !== ''">
              <span class="label">External Address</span>
              <span class="value">{{ nodeNetwork.publicIp || "NA" }}</span>
            </div>
            <div class="info-item-compact" *ngIf="nodeNetwork.ipType && nodeNetwork.ipType !== 'NA' && nodeNetwork.ipType.trim() !== ''">
              <span class="label">IP Type</span>
              <span class="value">{{ nodeNetwork.ipType || "NA" }}</span>
            </div>
            <div class="info-item-compact" *ngIf="nodeNetwork.dns && nodeNetwork.dns !== 'NA' && nodeNetwork.dns.trim() !== ''">
              <span class="label">DNS Name</span>
              <span class="value">{{ nodeNetwork.dns || "NA" }}</span>
            </div>
            <div class="info-item-compact" *ngIf="nodeNetwork.macAddress && nodeNetwork.macAddress !== 'NA' && nodeNetwork.macAddress.trim() !== ''">
              <span class="label">MAC Address</span>
              <span class="value">{{ nodeNetwork.macAddress || "NA" }}</span>
            </div>
            <div class="info-item-compact" *ngIf="nodeNetwork.gatewayName && nodeNetwork.gatewayName !== 'NA' && nodeNetwork.gatewayName.trim() !== ''">
              <span class="label">Gateway</span>
              <span class="value">{{ nodeNetwork.gatewayName || "NA" }}</span>
            </div>
          </div>
        </section>
      }
    </mat-card-content>
  </mat-card>

  <!-- Loading Spinner -->
  <ngx-spinner bdColor="rgba(0,0,0,0)" size="default" zIndex="1" color="var(--s-primary-color)" type="ball-spin"
    [fullScreen]="false">
    <p class="pleaseWait">Please wait ...</p>
  </ngx-spinner>
</div>

<!-- Tooltip Template -->
<ng-template #htmlContentTooltip>
  <div *ngIf="tooltipHtml != ''" [innerHTML]="tooltipHtml | safeHtml"></div>
</ng-template>
